import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { AnalyticsProvider } from "use-analytics";
import { analytics } from "@lxp-app/components/molecules/analytics/analytics";
import "./index.css";
import "./i18n";
import App from "./App.tsx";
import { store } from "./store/store.ts";
import keycloak from "@lxp-app/auth/keycloak.ts";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
(window as any).global = window;

createRoot(document.getElementById("root")!).render(
  <ReactKeycloakProvider authClient={keycloak}>
    <StrictMode>
      <Provider store={store}>
        <AnalyticsProvider instance={analytics}>
          <App />
        </AnalyticsProvider>
      </Provider>
    </StrictMode>
  </ReactKeycloakProvider>
);
